import { pageClick } from '@wix/bi-logger-customer-care-data/v2';
import { Box, Button, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

import { PRODUCTION_DOMAIN, BI } from '../../../constants';
import { DATA_HOOKS } from '../../../dataHooks';
import { useBI } from '../../../hooks/useBI';


import css from './index.module.scss';

type LoginSectionProps = {
  articleId: string;
};

export const LoginSection = ({ articleId }: LoginSectionProps) => {
  const { t } = useTranslation();
  const { asPath, locale } = useRouter();
  const { sendBIEvent } = useBI();

  const returnUrl = `https://${PRODUCTION_DOMAIN}/${locale}${asPath}`;
  const loginUrl = `https://users.wix.com/signin?view=sign-up&sendEmail=true&loginCompName=SignUp_Mobile&referralInfo=SignUp_Mobile&postSignUp=${returnUrl}&postLogin=${returnUrl}&loginDialogContext=login&originUrl=${returnUrl}&forceRender=true`;

  const handleLoginClick = useCallback(async () => {
    await sendBIEvent(
      pageClick({
        clicked_item_type: BI.CLICKED_ITEM_TYPES.HELPMATE_LOGIN_CTA,
        clicked_text: t('header.log-in'),
        item_id: articleId,
        kb_lang: locale as string,
        source_name: BI.SOURCE_NAMES.ARTICLE,
      })
    );
    window.open(loginUrl, '_self');
  }, [sendBIEvent, articleId, locale, loginUrl, t]);

  return <Box className={css.loginSectionWrapper}>
    <Box className={css.loginSectionHeader} direction="vertical">
      <Text size="small" weight="bold" dataHook={DATA_HOOKS.LOGIN_SECTION_HEADER}>{t('copilot.header.login.section')}</Text>
      <Text size="small" weight="thin" dataHook={DATA_HOOKS.LOGIN_SECTION_DESCRIPTION}>{t('copilot.description.login.section')}</Text>
    </Box>
    <Button size="small" skin="ai" dataHook={DATA_HOOKS.LOGIN_SECTION_BUTTON} onClick={handleLoginClick}>{t('header.log-in')}</Button>
  </Box>;
};
